import styled from '@emotion/styled';
import { Box, Typography, Button } from '@mui/material';
import * as React from 'react';
import { FC, useState } from 'react';

import { Colors } from '@/assets';

interface IProps {
    sizeIcon?: number;
}
export const PrimaryTooltip: FC<IProps> = ({ sizeIcon = 18, children }) => {
    return (
        <Box
            sx={{
                position: 'relative',
                ':hover p': {
                    color: Colors.orangeRed
                },
                ':hover .tooltip-text': {
                    opacity: 1,
                    zIndex: 1,
                    transition: 'opacity 0.3s ease-in-out'
                }
            }}
        >
            <Typography
                sx={{
                    fontSize: sizeIcon
                }}
                className="fal fa-question-circle"
            ></Typography>
            <Box
                className="tooltip-text"
                sx={{
                    opacity: 0,
                    transition: 'opacity 0.3s ease-in-out',
                    zIndex: -1,
                    position: 'absolute',
                    left: 0,
                    pt: 1.3,
                    transform: 'translateX(-50%)'
                }}
            >
                <Box
                    sx={{
                        border: '2px solid',
                        borderColor: Colors.geyserGrey,
                        borderRadius: 4,
                        background: Colors.white,
                        p: 2
                    }}
                >
                    {children}
                </Box>
            </Box>
        </Box>
    );
};
